import store from '@/store'

export default {    
    requestUseConfig(config){
        //显示全局loading
        store.tips.showLoading();
        //为http请求添加accessToken
        var access_token = store.user.get_access_token();
        if(access_token == null){
          //token 为空，重新登陆
          store.user.relogin();
        }          
        config.headers.Authorization = 'Bearer ' + access_token;
        return config;
    },
    requestUseError(error){
        return Promise.reject(error);
    },
    responseUseRes(res){
        //隐藏全局loading
        store.tips.hideLoading();
        return res;
    },
    responseUseError(error){
        //隐藏全局loading
        store.tips.hideLoading();
        if (error.response) {
          if (error.response.status === 500) {
            //全局提示errorInfo
            console.log(error.response.data);
            if(error.response.data.code == 100002){
              store.tips.showErrorInfo('参数检验不通过', error.response.data.title, 60*1000);
            }else{
              store.tips.showErrorInfo(error.response.data.title, error.response.data.msg, 60*1000);
            }      
            //return error;
            //return Promise.reject(error);
          } else if (error.response.status === 401) {
            store.user.relogin();
          } else {
            console.log('Error', error.message);
            alert('接口请求失败或超时！请刷新重试.');
          }
        } else {
          alert('接口请求失败或超时！请刷新重试.');
        }
        return Promise.reject(error);
    },
    relogin(){
       
    }
}


// WEBPACK FOOTER //
// ./src/components/interceptor/axios/index.js